import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import SellerProduct from "../../components/SellerProduct/SellerProduct";
import AddProducts from "../../components/SellerProduct/AddProducts";
import { FetchProductsApi } from "../../ApiCalls/AddProducts";
import ProductView from "../../components/SellerProduct/ProductView";
import EditProduct from "../../components/SellerProduct/EditProduct";

const SellerProducts = () => {
  const [fetchedProducts, setFetchedProducts] = useState([]);

  const refetchProducts = async () => {
    try {
      const products = await FetchProductsApi();
      setFetchedProducts(products);
    } catch (error) {
      console.error("Error refetching products:", error);
    }
  };

  useEffect(() => {
    refetchProducts();
  }, []);
  return (
    <div className="h-full w-full">
      <Routes>
        <Route
          path="view_products"
          element={
            <SellerProduct
              fetchedProducts={fetchedProducts}
              refetchProducts={refetchProducts}
            />
          }
        />
        <Route
          path="add_product"
          element={<AddProducts mode="add" refetchProducts={refetchProducts} />}
        />
        <Route
          path="edit/:id"
          element={
            <EditProduct mode="edit" refetchProducts={refetchProducts} />
          }
        />
        <Route
          path="view/:id"
          element={<ProductView refetchProducts={refetchProducts} />}
        />
      </Routes>
    </div>
  );
};
export default SellerProducts;
